export default "__VITE_ASSET__v9wJp_MH__"